import { useEffect, useState } from "react";
import { getMyInvoices } from "../../../api/invoiceClientService";

export default function ClientInvoicesPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState("");

    useEffect(() => {
        const load = async () => {
            try {
                const data = await getMyInvoices();
                setItems(Array.isArray(data) ? data : []);
            } catch (e) {
                setErr("Error loading invoices");
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);

    if (loading) return <p>Loading�</p>;
    if (err) return <p className="text-red-500">{err}</p>;

    return (
        <div className="p-6 max-w-4xl mx-auto">
            <h1 className="text-xl font-bold mb-4">My Invoices</h1>

            {items.length === 0 ? (
                <p>No invoices found.</p>
            ) : (
                <table className="w-full text-sm border">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border p-2">#</th>
                            <th className="border p-2">Amount</th>
                            <th className="border p-2">Status</th>
                            <th className="border p-2">Due</th>
                            <th className="border p-2">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {items.map((i) => (
                            <tr key={i.id}>
                                <td className="border p-2">{i.number}</td>
                                <td className="border p-2">
                                    {i.amount} {i.currency ?? "EUR"}
                                </td>
                                <td className="border p-2">{i.status}</td>
                                <td className="border p-2">
                                    {i.dueDate
                                        ? new Date(i.dueDate).toLocaleDateString()
                                        : "�"}
                                </td>
                                <td className="border p-2">
                                    {i.pdfUrl ? (
                                        <a
                                            href={i.pdfUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-indigo-600 underline"
                                        >
                                            Download PDF
                                        </a>
                                    ) : (
                                        "�"
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}